import axios from '../../config/axios';

export function getItemTypes() {
    return axios().get(`/stock/item-types`);
}

export function getItemGroups() {
    return axios().get(`/stock/item-groups`);
}

export function getMeasureUnits() {
    return axios().get(`/stock/measure-units`);
}

export function getItemAccountTypes() {
    return axios().get(`/stock/item-account-type`);
}

export function getAccounts() {
    return axios().get(`/stock/account`);
}

export function getIdempotentKey() {
    return axios().get(`/stock/idempotent`)
}